export default "__VITE_ASSET__EoYxx91z__"